<div class="densest">
  <div>
    <label [for]="id" class="datepicker-label"
      >{{ label }}<span *ngIf="required"> *</span></label
    >
  </div>
  <mat-form-field appearance="outline" class="datepicker-form-field">
    <input
      (click)="clearInput()"
      [formControl]="control"
      [id]="id"
      [matDatepicker]="picker"
      [placeholder]="placeholder"
      matInput
    />
    <mat-icon
      *ngIf="control.status == 'INVALID' && control.touched"
      class="datepicker-icon"
      matSuffix
      >error_outline
    </mat-icon>
    <mat-datepicker-toggle [for]="picker" matIconSuffix matSuffix />
    <mat-datepicker #picker matSuffix />
    <mat-error class="datepicker-error">{{ errorText }}</mat-error>
  </mat-form-field>
</div>
